import { H2, H3, P} from "../../../components/typography/styled";
import { PrivacyPolicyWrapper, PolicyContainer, PolicyTitle,} from "./styled";

export const TermsAndConditions = () => {
    return (
        <PrivacyPolicyWrapper>
            <PolicyContainer>
                <PolicyTitle>Terms of Use</PolicyTitle>
                <P>Effective: January 1, 2026</P>
            
                <P>Thank you for using WorkPlacePay!</P>
            
                <P>
                    These Terms of Use apply to your use of WorkPlacePay services for
                    companies, along with any associated software applications and
                    websites (all together, "Services"). These Terms form an agreement
                    between you and Focus Group, LLC, a Nigerian ICT company, and they
                    include our Service Terms and important provisions. By using our
                    Services, you agree to these Terms.
                </P>
            
                <P>Our Business Terms govern use of WorkPlacePay services for companies.</P>
            
                <P>
                    Our Privacy Policy explains how we collect and use personal
                    information. Although it does not form part of these Terms, it is an
                    important document that you should read.
                </P>
            
                <div>
                    <H2>Who we are</H2>
                    <P>
                        Focus Group is an ICT soutions company. Our mission is to provide
                        end-to-end ICT solutions and services to solve present and future
                        problems.
                    </P>
                </div>
            
                <div>
                    <H2>Registration and access</H2>
                    <H3>Registration</H3>
                    <P>
                        You must provide accurate and complete information to
                        register for a company's account to use our Services. You may not
                        share your account credentials or make your account available to
                        anyone else and are responsible for all activities that occur under
                        your account. If you create an account or use the Services on
                        behalf of another entity, you must have the authority to accept
                        these Terms on their behalf.
                    </P>
                </div>
            
                <div>
                    <H3>Using our Services</H3>
                    <P>
                        Subject to your compliance with these Terms, you may access and use
                        our Services. In using our Services, you must comply with all
                        applicable laws, and any other documentation, guidelines, or
                        policies we make available to you.
                    </P>
                </div>
            
                <div>
                    <H3>Software</H3>
                    <P>
                        WorkPlacePay may allow you to download software, such as mobile
                        applications, which may update automatically to ensure you're
                        using the latest version.
                    </P>
                </div>
            
                <div>
                    <H3>Third party Services</H3>
                    <P>
                        WorkPlacePay may include third party software, products, or
                        services, ("Third Party Services") and some parts of our Services,
                        like our browse feature, may include output from those services
                        ("Third Party Output"). Third Party Services and Third Party
                        Output are subject to their own terms, and we are not responsible
                        for them.
                    </P>
                    <H3>Feedback</H3>
                    <P>
                        We appreciate your feedback, and you agree that we may
                        use it without restriction or compensation to you.
                    </P>
                </div>
            
                <div>
                    <H2>Paid accounts</H2>
            
                    <div>
                    <H3>Billing</H3>
                    <P>
                        If you make any payments(Plans, credit purchase etc.), you will
                        provide complete and accurate billing information to the
                        provided payment gateways. For paid subscriptions, we will
                        automatically charge your payment method on each agreed-upon
                        subscription plan until you cancel. You're responsible for all
                        applicable taxes, and we'll charge tax when required. If your
                        payment cannot be completed, we may downgrade your account or
                        suspend your access to our Services until payment is received.
                    </P>
                    </div>
            
                    <div>
                    <H3>Cancellation and refund</H3>
                    <P>
                        You can cancel your paid subscription at any time. Credit tokens
                        are non-refundable, but any refundable commitment made before
                        cancellation can be reimbursed.
                    </P>
                    </div>
            
                    <div>
                    <H3>Changes</H3>
                    <P>
                        We may change our prices from time to time. If we increase our
                        subscription prices, we will give you at least 30 days' notice
                        and any price increase will take effect on your next renewal so
                        that you can cancel if you do not agree to the price increase.
                    </P>
                    </div>
            
                    <div>
                    <H3>Payroll plans</H3>
                    <P>All information regarding our payroll plans can be found on the landing page.</P>
                    </div>
                </div>
            
                <div>
                    <H2>Termination and suspension</H2>
                    <H3>Termination</H3>
                    <P>
                        You are free to stop using our Services at any time.
                        We reserve the right to suspend or terminate your access to our
                        Services or delete your account if we determine You breached these
                        Terms or our Usage Policies.
                    </P>
                    <P>
                        We also may terminate your account if it has been inactive for
                        over a year. If we do, we will provide you with advance notice.
                    </P>
                </div>
            
                <div>
                    <H3>Appeals</H3>
                    <P>
                        If you believe we have suspended or terminated your account in
                        error, you can file an appeal with us by contacting our Support
                        team.
                    </P>
                </div>
            
                <div>
                    <H3>Discontinuation of Services</H3>
                    <P>
                        We may decide to discontinue our Services, but if we do, we will
                        give you advance notice and a refund for any prepaid, unused
                        refundable commitment.
                    </P>
                </div>
            </PolicyContainer>
        </PrivacyPolicyWrapper>
    );
};